import React from 'react';
import T from 'prop-types';
import {
  CashbackLayout,
  CashbackMainColumn,
  CashbackMetrics,
  CashbackSideColumn
} from 'routes/App/cashback/styles';
import IconCashbackRepeatCustomers from 'routes/App/cashback/icons/IconCashbackRepeatCustomers';
import IconCashbackRedeemed from 'routes/App/cashback/icons/IconCashbackRedeemed';
import IconCashbackOutstanding from 'routes/App/cashback/icons/IconCashbackOutstanding';
import CashbackMetricCard from './CashbackMetricCard';
import ParticipationChart from './ParticipationChart';
import RecentOrders from './RecentOrders';
import MomentumPanel from './MomentumPanel';
import GrowthTipsPanel from './GrowthTipsPanel';
import ResultsPanel from './ResultsPanel';
import RetentionBanner from './RetentionBanner';

const formatCurrency = (value) => {
  if (value == null) return '$0';
  return `$${value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  })}`;
};

const formatPercent = (value) => {
  if (value == null) return '0%';
  return `${value}%`;
};

const CashbackDashboard = ({data}) => {
  const hasStrongPerformance = data?.state === 'StrongPerformance';
  const showRetentionBanner =
    hasStrongPerformance &&
    data?.showRetentionBanner &&
    data?.retentionMultiplier;

  return (
    <>
      <CashbackMetrics>
        <CashbackMetricCard
          icon={<IconCashbackRepeatCustomers />}
          title='Repeat customers'
          tooltip='% of cashback customers with 2+ orders. Change vs. previous 7 days'
          value={data?.repeatCustomers?.value}
          formatValue={formatPercent}
        />
        <CashbackMetricCard
          icon={<IconCashbackRedeemed />}
          title='Credits redeemed'
          tooltip='Total credit customers used in this period. Change vs. previous 7 days'
          value={data?.creditsRedeemed?.value}
          trendPercent={
            hasStrongPerformance ? data?.creditsRedeemed?.trendPercent : null
          }
          formatValue={formatCurrency}
        />
        <CashbackMetricCard
          icon={<IconCashbackOutstanding />}
          title='Credits outstanding'
          tooltip="Total credit customers earned but haven't used yet. Change vs. previous 7 days"
          value={data?.creditsOutstanding?.value}
          trendPercent={
            hasStrongPerformance ? data?.creditsOutstanding?.trendPercent : null
          }
          formatValue={formatCurrency}
        />
      </CashbackMetrics>

      {showRetentionBanner && (
        <div style={{marginTop: 25}}>
          <RetentionBanner retentionMultiplier={data.retentionMultiplier} />
        </div>
      )}

      <CashbackLayout>
        <CashbackMainColumn>
          <ParticipationChart weeklyParticipation={data?.weeklyParticipation} />
          <RecentOrders orders={data?.recentOrders} />
        </CashbackMainColumn>
        <CashbackSideColumn>
          {hasStrongPerformance ? (
            <ResultsPanel
              invested={data?.invested}
              generated={data?.generated}
              roi={data?.roi}
            />
          ) : (
            <>
              <MomentumPanel
                customersEarnedCredits={data?.customersEarnedCredits}
              />
              <GrowthTipsPanel />
            </>
          )}
        </CashbackSideColumn>
      </CashbackLayout>
    </>
  );
};

CashbackDashboard.propTypes = {
  data: T.object
};

CashbackDashboard.defaultProps = {
  data: null
};

export default CashbackDashboard;
